<form [formGroup]="form" (submit)="$event.preventDefault()">
  <app-equipment-details [form]="form" />
  <app-equipment-description [form]="form" [configEN]="configEN" [configRU]="configRU" [configKZ]="configKZ" />
  
  @if (!hasEquipment()) {
    <div class="equipment-error-message">
      <mat-icon svgIcon="error"></mat-icon>
      <span>Selecting one of the equipments is mandatory</span>
    </div>
  }
  
  <app-e1-table [values]="e1Table.value" (changed)="getE1Data($event)" />
  <app-ge-predix-table [values]="gePredixTable.value" (changed)="getPredixData($event)" />
</form>
